import type { components } from '@/api/qraft/schema';
import type { LanguageCode } from './types/congregationGroupTypes';

// `FollowUpEntry`, `FollowUpUser`, `FollowUpActivityEvent`, `FollowUpEntryStudent`,
// `FollowUpEntryPartner`, `FollowUpEntryDetail`, `mockFollowUpEntryDetails` and
// `FOLLOW_UP_COUNTRY_OPTIONS` were removed in W4.6: the coordinator and partner
// follow-up surfaces read the real `GET /v3/follow-ups/*` operations now. Do not
// re-add them.

// `mockAdoptionRequests` was removed in W3.6: the AdoptionRequests widget reads
// `GET /v3/adoption/requests`. Do not re-add it — the `AdoptionRequest` type it
// was its last consumer, and the type was deleted with it.
export const mockMemberData = {
  email: 'janedoe@gmail.com',
  lastLogin: '2025-10-30T12:00:00Z',
  lastActivity: '2025-10-30T12:00:00Z',
  lastActivityLiteapp: '2025-10-30T12:00:00Z',
  lastActivityFullapp: '2025-10-30T12:00:00Z',
  registeredAt: '2025-10-30T12:00:00Z',
  adoptionDetails: 'n/a',
  firstName: 'Jane',
  lastName: 'Doe',
  birthYear: '2000',
  gender: 'Female',
  country: 'United States',
  city: 'Grand Blanc',
  state: 'Michigan',
  preferredLanguage: 'en' as LanguageCode,
  lessonDelivery: 'Web',
  howHeard: 'Other',
  religion: 'Christianity',
  maritalStatus: 'Prefer Not to Answer',
  siteLanguage: 'en' as LanguageCode,
  publicProfile: true,
  genderPreference: 'No Preference',
  studentBoard: true,
  group: 'WBS Internet Test',
};

export const mockSpiritualOnboarding = {
  believeInGod: 'Yes, I believe',
  explainBelieveInGod: 'Response',
  believeBible: 'Yes, I believe',
  jesusIs: 'the Son of God',
  selfDescription:
    'I believe I have already been saved and am currently at peace with God.',
  explainSelfDescription: 'Response',
  partOfCommunity: 'Yes',
  churchName: 'Name of place',
  baptized: 'I was baptized when I was plunged or immersed in water',
  baptismReasons:
    'for the remission of sins, to let people know I have been saved, commitment by my parents to raise me in the Christian faith',
  baptizedAndSaved: 'baptized and saved at the same time',
  baptismExplanation: 'Explanation',
  buriedWithChrist: 'I agree',
  wantToDieWithChrist:
    'I have already been baptized, and I am satisfied with the conditions of my baptism',
  wantHelperForBaptism: 'No',
  wantBible: 'No',
};

export const mockActivities = [
  {
    id: 1,
    studentName: 'S26 Howell',
    activityTitle: 'Time for Good News? (Part 2)',
    status: 'ready for you to grade',
    submittedDate: '3 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/1.jpg',
  },
  {
    id: 2,
    studentName: 'S26 Howell',
    activityTitle: 'Time for Good News? (Part 1)',
    status: 'ready for you to grade',
    submittedDate: '3 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/2.jpg',
  },
  {
    id: 3,
    studentName: 'S26 Howell',
    activityTitle: 'God Has Spoken of Mercy',
    status: 'ready for you to grade',
    submittedDate: '3 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/3.jpg',
  },
  {
    id: 4,
    studentName: 'S26 Howell',
    activityTitle: 'God Has Spoken of Judgment',
    status: 'ready for you to grade',
    submittedDate: '3 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/4.jpg',
  },
  {
    id: 5,
    studentName: 'S26 Howell',
    activityTitle: 'God Has Spoken of His Enemy',
    status: 'ready for you to grade',
    submittedDate: '3 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/5.jpg',
  },
  {
    id: 6,
    studentName: 'Lucas Martin',
    activityTitle: 'God Has Spoken Through His Writings',
    status: 'completed and graded',
    submittedDate: '4 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/1.jpg',
  },
  {
    id: 7,
    studentName: 'Sophie Dubois',
    activityTitle: 'Only One God Has Spoken',
    status: 'ready for you to grade',
    submittedDate: '4 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/6.jpg',
  },
  {
    id: 8,
    studentName: 'Jean Pate',
    activityTitle: 'God Has Spoken Through the Prophets',
    status: 'in progress',
    submittedDate: '4 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/2.jpg',
  },
  {
    id: 9,
    studentName: 'Roberta Williams',
    activityTitle: 'God Has Spoken Through Nature',
    status: 'ready for you to grade',
    submittedDate: '5 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/7.jpg',
  },
  {
    id: 10,
    studentName: 'Antoine Lefevre',
    activityTitle: 'The Way to Life',
    status: 'completed and graded',
    submittedDate: '5 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/3.jpg',
  },
  {
    id: 11,
    studentName: 'Robin Barron',
    activityTitle: 'Exploring Good News',
    status: 'ready for you to grade',
    submittedDate: '5 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/4.jpg',
  },
  {
    id: 12,
    studentName: 'Carlos Pereira',
    activityTitle: 'Experiencing Good News',
    status: 'in progress',
    submittedDate: '6 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/5.jpg',
  },
  {
    id: 13,
    studentName: 'Julien Moreau',
    activityTitle: 'Living Good News',
    status: 'ready for you to grade',
    submittedDate: '6 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/6.jpg',
  },
  {
    id: 14,
    studentName: 'Elizabeth Anderson',
    activityTitle: "Living With God's Family",
    status: 'completed and graded',
    submittedDate: '6 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/8.jpg',
  },
  {
    id: 15,
    studentName: 'Amy Hines',
    activityTitle: 'Choosing Good News',
    status: 'ready for you to grade',
    submittedDate: '7 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/9.jpg',
  },
  {
    id: 16,
    studentName: 'Marcus Johnson',
    activityTitle: 'Knowing Jesus Through His Messenger',
    status: 'in progress',
    submittedDate: '7 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/7.jpg',
  },
  {
    id: 17,
    studentName: 'Isabella Garcia',
    activityTitle: 'Knowing Jesus Through His Witnesses',
    status: 'ready for you to grade',
    submittedDate: '7 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/10.jpg',
  },
  {
    id: 18,
    studentName: 'Oliver Chen',
    activityTitle: 'Knowing Jesus Through His Prophecies',
    status: 'completed and graded',
    submittedDate: '8 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/8.jpg',
  },
  {
    id: 19,
    studentName: 'Emma Rodriguez',
    activityTitle: 'Knowing Jesus Through His Signs',
    status: 'ready for you to grade',
    submittedDate: '8 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/11.jpg',
  },
  {
    id: 20,
    studentName: 'William Kim',
    activityTitle: 'Knowing Jesus As The Light',
    status: 'in progress',
    submittedDate: '8 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/9.jpg',
  },
  {
    id: 21,
    studentName: 'Sophia Taylor',
    activityTitle: 'Knowing Jesus As The Life',
    status: 'ready for you to grade',
    submittedDate: '9 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/12.jpg',
  },
  {
    id: 22,
    studentName: 'James Wilson',
    activityTitle: 'Knowing Jesus As The Lord',
    status: 'completed and graded',
    submittedDate: '9 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/10.jpg',
  },
  {
    id: 23,
    studentName: 'Mia Anderson',
    activityTitle: 'The Seed',
    status: 'ready for you to grade',
    submittedDate: '9 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/13.jpg',
  },
  {
    id: 24,
    studentName: 'Benjamin Thomas',
    activityTitle: 'The True Gospel',
    status: 'in progress',
    submittedDate: '10 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/11.jpg',
  },
  {
    id: 25,
    studentName: 'Charlotte Martinez',
    activityTitle: 'The Gospel Presented',
    status: 'ready for you to grade',
    submittedDate: '10 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/14.jpg',
  },
  {
    id: 26,
    studentName: 'Daniel Lee',
    activityTitle: 'The Gospel Response',
    status: 'completed and graded',
    submittedDate: '10 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/12.jpg',
  },
  {
    id: 27,
    studentName: 'Amelia White',
    activityTitle: 'Authorized Messengers',
    status: 'ready for you to grade',
    submittedDate: '11 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/15.jpg',
  },
  {
    id: 28,
    studentName: 'Henry Harris',
    activityTitle: 'Priestly Messengers',
    status: 'in progress',
    submittedDate: '11 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/13.jpg',
  },
  {
    id: 29,
    studentName: 'Evelyn Clark',
    activityTitle: 'Imperfect Messengers',
    status: 'ready for you to grade',
    submittedDate: '11 months ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/16.jpg',
  },
  {
    id: 30,
    studentName: 'Alexander Lewis',
    activityTitle: 'Healthy Motives',
    status: 'completed and graded',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/14.jpg',
  },
  {
    id: 31,
    studentName: 'Harper Robinson',
    activityTitle: 'Power Tools',
    status: 'ready for you to grade',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/17.jpg',
  },
  {
    id: 32,
    studentName: 'Michael Walker',
    activityTitle: 'Team Tools',
    status: 'in progress',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/15.jpg',
  },
  {
    id: 33,
    studentName: 'Abigail Hall',
    activityTitle: 'Christ-likness',
    status: 'ready for you to grade',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/18.jpg',
  },
  {
    id: 34,
    studentName: 'Ethan Allen',
    activityTitle: 'One Instructor',
    status: 'completed and graded',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/16.jpg',
  },
  {
    id: 35,
    studentName: 'Emily Young',
    activityTitle: 'Preparing The Next Generation',
    status: 'ready for you to grade',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/19.jpg',
  },
  {
    id: 36,
    studentName: 'Matthew King',
    activityTitle: 'Historical Christian Evidences (Part 1)',
    status: 'in progress',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/17.jpg',
  },
  {
    id: 37,
    studentName: 'Elizabeth Wright',
    activityTitle: 'Historical Christian Evidences (Part 2)',
    status: 'ready for you to grade',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/20.jpg',
  },
  {
    id: 38,
    studentName: 'Joseph Lopez',
    activityTitle: 'Bible History 1 (Part 1)',
    status: 'completed and graded',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/18.jpg',
  },
  {
    id: 39,
    studentName: 'Victoria Hill',
    activityTitle: 'Bible History 1 (Part 2)',
    status: 'ready for you to grade',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/21.jpg',
  },
  {
    id: 40,
    studentName: 'David Scott',
    activityTitle: 'Bible History 1 (Part 3)',
    status: 'in progress',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/19.jpg',
  },
  {
    id: 41,
    studentName: 'Madison Green',
    activityTitle: 'God Has Spoken Through a Prophet Like Moses',
    status: 'ready for you to grade',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/22.jpg',
  },
  {
    id: 42,
    studentName: 'Christopher Adams',
    activityTitle: 'Time for Good News? (Part 2)',
    status: 'completed and graded',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/20.jpg',
  },
  {
    id: 43,
    studentName: 'Grace Baker',
    activityTitle: 'God Has Spoken of Mercy',
    status: 'ready for you to grade',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/23.jpg',
  },
  {
    id: 44,
    studentName: 'Andrew Nelson',
    activityTitle: 'God Has Spoken of Judgment',
    status: 'in progress',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/21.jpg',
  },
  {
    id: 45,
    studentName: 'Chloe Carter',
    activityTitle: 'God Has Spoken of His Enemy',
    status: 'ready for you to grade',
    submittedDate: '1 year ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/24.jpg',
  },
];

export type MockStudyHelper = {
  id: string;
  name: string;
  gender: string;
  state?: string;
  country: string;
  avatarUrl: string;
  registeredAt?: string;
  responseRate?: number;
  activeStudents?: number;
};

export const mockStudyHelpers: MockStudyHelper[] = [
  {
    id: '1234',
    name: 'James Okafor',
    gender: 'Male',
    country: 'Nigeria',
    avatarUrl: 'https://randomuser.me/api/portraits/men/11.jpg',
    registeredAt: '2020-07-24T12:00:00Z',
    responseRate: 92,
    activeStudents: 14,
  },
  {
    id: '1235',
    name: 'Maria Santos',
    gender: 'Female',
    state: 'São Paulo',
    country: 'Brazil',
    avatarUrl: 'https://randomuser.me/api/portraits/women/47.jpg',
    registeredAt: '2019-03-15T12:00:00Z',
    responseRate: 87,
    activeStudents: 9,
  },
  {
    id: '1236',
    name: 'David Nguyen',
    gender: 'Male',
    state: 'California',
    country: 'United States',
    avatarUrl: 'https://randomuser.me/api/portraits/men/12.jpg',
    registeredAt: '2021-08-09T12:00:00Z',
    responseRate: 75,
    activeStudents: 6,
  },
  {
    id: '1237',
    name: 'Amara Diallo',
    gender: 'Female',
    country: 'Senegal',
    avatarUrl: 'https://randomuser.me/api/portraits/women/45.jpg',
    registeredAt: '2022-01-03T12:00:00Z',
    responseRate: 98,
    activeStudents: 11,
  },
  {
    id: '1238',
    name: 'Lucas Müller',
    gender: 'Male',
    state: 'Bavaria',
    country: 'Germany',
    avatarUrl: 'https://randomuser.me/api/portraits/men/13.jpg',
    registeredAt: '2021-09-08T12:00:00Z',
    responseRate: 83,
    activeStudents: 7,
  },
  {
    id: '1239',
    name: 'Priya Sharma',
    gender: 'Female',
    state: 'Maharashtra',
    country: 'India',
    avatarUrl: 'https://randomuser.me/api/portraits/women/49.jpg',
    registeredAt: '2020-02-20T12:00:00Z',
    responseRate: 91,
    activeStudents: 13,
  },
  {
    id: '1240',
    name: 'Carlos Reyes',
    gender: 'Male',
    country: 'Mexico',
    avatarUrl: 'https://randomuser.me/api/portraits/men/15.jpg',
    registeredAt: '2023-06-11T12:00:00Z',
    responseRate: 70,
    activeStudents: 4,
  },
  {
    id: '1241',
    name: 'Fatima Al-Hassan',
    gender: 'Female',
    country: 'Egypt',
    avatarUrl: 'https://randomuser.me/api/portraits/women/44.jpg',
    registeredAt: '2021-11-30T12:00:00Z',
    responseRate: 95,
    activeStudents: 16,
  },
  {
    id: '1242',
    name: 'Ethan Brooks',
    gender: 'Male',
    state: 'Ontario',
    country: 'Canada',
    avatarUrl: 'https://randomuser.me/api/portraits/men/17.jpg',
    registeredAt: '2022-04-05T12:00:00Z',
    responseRate: 80,
    activeStudents: 8,
  },
  {
    id: '1243',
    name: 'Sofia Moreau',
    gender: 'Female',
    state: 'Île-de-France',
    country: 'France',
    avatarUrl: 'https://randomuser.me/api/portraits/women/48.jpg',
    registeredAt: '2023-10-17T12:00:00Z',
    responseRate: 88,
    activeStudents: 5,
  },
];

export interface CampaignStudent {
  id: number;
  name: string;
  avatar: string | null;
  age: string;
  gender: string;
  language: LanguageCode;
  location: string;
  intro: 'started' | 'completed';
  registeredDate: string;
  mode: components['schemas']['ProfileType'];
  linkUserId?: number;
}

export interface PersonalCampaign {
  id: string;
  name: string;
  enabled: boolean;
  campaignUrl: string;
  description: string;
  students: CampaignStudent[];
}

export const mockPersonalCampaign: PersonalCampaign = {
  id: 'campaign-1',
  name: "Savannah-SH Howell's personal campaign",
  enabled: true,
  campaignUrl: 'https://savannah-sh-howell.wbs.test',
  description:
    'This is your individual Connect Web Address. Individuals who register through the URL below will only be made available for you to adopt and help.',
  students: [
    {
      id: 5001,
      name: 'Michael Torres',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      age: '32',
      gender: 'Male',
      language: 'en',
      location: 'Austin, Texas',
      intro: 'completed',
      registeredDate: '2026-02-01T12:00:00Z',
      mode: 'WEB_STUDENT',
      linkUserId: 5001,
    },
    {
      id: 5002,
      name: 'Lisa Chen',
      avatar: 'https://randomuser.me/api/portraits/women/41.jpg',
      age: '28',
      gender: 'Female',
      language: 'en',
      location: 'San Francisco, California',
      intro: 'started',
      registeredDate: '2026-02-05T12:00:00Z',
      mode: 'WEB_STUDENT',
      linkUserId: 5002,
    },
    {
      id: 5003,
      name: 'Daniel Okonkwo',
      avatar: null,
      age: '45',
      gender: 'Male',
      language: 'en',
      location: 'Lagos, Nigeria',
      intro: 'completed',
      registeredDate: '2026-02-08T12:00:00Z',
      mode: 'WEB_STUDENT',
      linkUserId: 5003,
    },
    {
      id: 5004,
      name: 'Patricia Kovács',
      avatar: 'https://randomuser.me/api/portraits/women/50.jpg',
      age: '38',
      gender: 'Female',
      language: 'es',
      location: 'Madrid, Spain',
      intro: 'started',
      registeredDate: '2026-02-12T12:00:00Z',
      mode: 'WEB_STUDENT',
      linkUserId: 5004,
    },
    {
      id: 5005,
      name: 'James Wilson',
      avatar: 'https://randomuser.me/api/portraits/men/55.jpg',
      age: '55',
      gender: 'Male',
      language: 'en',
      location: 'Charlotte, North Carolina',
      intro: 'completed',
      registeredDate: '2026-02-15T12:00:00Z',
      mode: 'POSTAL_STUDENT',
      linkUserId: 5005,
    },
  ],
};
export const mockNotifications = [
  {
    id: 1,
    message: [
      { type: 'text' as const, value: 'John Doe has enrolled in ' },
      { type: 'bold' as const, value: 'Bible Study 101' },
      {
        type: 'text' as const,
        value: 'and is awaiting a response',
      },
    ],
    time: '2 minutes ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
    isRead: false,
  },
  {
    id: 2,
    message: [
      { type: 'text' as const, value: 'Sarah Smith submitted ' },
      { type: 'bold' as const, value: 'Quiz #3' },
    ],
    time: '15 minutes ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/44.jpg',
    isRead: false,
  },
  {
    id: 3,
    message: [
      { type: 'text' as const, value: 'New follow-up request from ' },
      { type: 'bold' as const, value: 'Mike Johnson' },
    ],
    time: '1 hour ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/65.jpg',
    isRead: false,
  },
  {
    id: 4,
    message: [
      { type: 'text' as const, value: 'Spring Campaign has reached ' },
      { type: 'bold' as const, value: '75% completion' },
    ],
    time: '2 hours ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/12.jpg',
    isRead: true,
  },
  {
    id: 5,
    message: [
      { type: 'text' as const, value: 'New comment on your post by ' },
      { type: 'bold' as const, value: 'Emily Davis' },
    ],
    time: '3 hours ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/65.jpg',
    isRead: true,
  },
  {
    id: 6,
    message: [
      { type: 'text' as const, value: 'New comment on your post by ' },
      { type: 'bold' as const, value: 'Emily Davis' },
    ],
    time: '3 hours ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/65.jpg',
    isRead: true,
  },
  {
    id: 7,
    message: [
      { type: 'text' as const, value: 'New comment on your post by ' },
      { type: 'bold' as const, value: 'Emily Davis' },
    ],
    time: '3 hours ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/65.jpg',
    isRead: true,
  },
  {
    id: 8,
    message: [
      { type: 'text' as const, value: 'New comment on your post by ' },
      { type: 'bold' as const, value: 'Emily Davis' },
    ],
    time: '3 hours ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/65.jpg',
    isRead: true,
  },
];

export const mockMessages = [
  {
    id: 1,
    senderName: 'Dr. Sarah Wilson',
    preview:
      'Thank you for your feedback on the Bible study materials. I wanted to follow up on your suggestions about...',
    time: '5 minutes ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/45.jpg',
    isRead: false,
  },
  {
    id: 2,
    senderName: 'Mark Thompson',
    preview:
      'The quarterly report is ready for review. Please let me know if you need any additional information.',
    time: '1 hour ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/23.jpg',
    isRead: false,
  },
  {
    id: 3,
    senderName: 'Jennifer Lee',
    preview:
      "Great job on the recent campaign! The response has been overwhelming and we've exceeded our goals.",
    time: '2 hours ago',
    avatarUrl: 'https://randomuser.me/api/portraits/women/32.jpg',
    isRead: true,
  },
  {
    id: 4,
    senderName: 'Admin Team',
    preview:
      'System maintenance is scheduled for this weekend. Please save your work and plan accordingly.',
    time: '1 day ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/54.jpg',
    isRead: true,
  },
  {
    id: 5,
    senderName: 'Admin Team',
    preview:
      'System maintenance is scheduled for this weekend. Please save your work and plan accordingly.',
    time: '1 day ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/54.jpg',
    isRead: true,
  },
  {
    id: 6,
    senderName: 'Admin Team',
    preview:
      'System maintenance is scheduled for this weekend. Please save your work and plan accordingly.',
    time: '1 day ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/54.jpg',
    isRead: true,
  },
  {
    id: 7,
    senderName: 'Admin Team',
    preview:
      'System maintenance is scheduled for this weekend. Please save your work and plan accordingly.',
    time: '1 day ago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/54.jpg',
    isRead: true,
  },
];

export const mockQuizData = {
  id: 'quiz-1',
  title: 'The Resurrection of Jesus Quiz',
  slug: 'resurrection-of-jesus-quiz',
  lessonSlug: 'resurrection-of-jesus',
  questions: [
    {
      id: 'q1',
      type: 'single',
      question:
        'Death by crucifixion generally took 36 to 72 hours, but Jesus died in 6 hours.',
      options: ['True', 'False'],
      hint: "Consider what the lesson taught about the unusual circumstances of Jesus' death.",
    },
    {
      id: 'q2',
      type: 'cloze_answer',
      question:
        'Jesus made several claims concerning His life and death. __________ contains the claim that He would die by crucifixion. ___________ contains the claim that He would die at a particular time. __________ contains the claim that He had the power to lay His life down, and no one could take His life from Him. (These may be used to fill in the blanks: John 2:4; Acts 2:38; Matthew 20:19/John 3:14; John 10:17-18; Mark 16:15)',
    },
    {
      id: 'q3',
      type: 'single',
      question:
        'What three-pronged argument does Paul present about himself to prove that Jesus appeared to him?',
      options: [
        'That he was proud, a Pharisee, and prominent.',
        'That he was prejudice, proud, and promised.',
        'That he was prejudice, a fanatic and prominent.',
        'None of the above.',
      ],
      hint: "Think about Paul's background and what he was known for before his conversion.",
    },
    {
      id: 'q4',
      type: 'multiple',
      question:
        "No one could kill Jesus, although attempts were made on His life. There are five facts that make good Christ's claim to have control over the circumstances touching His life to the point of fulfilling His destiny at the cross. Identify <strong>three</strong> of them below.",
      options: [
        'Officers were sent by the ruling Jews to arrest Christ but even the arrest was not carried out.',
        'On the island of Crete the members of the synagogue attempted to throw Jesus off the cliff the city was built on.',
        'The Sanhedrin met at night to devise a plan to execute him without a public trial.',
        'A number of attempts to kill Jesus by public hanging also failed.',
        'Herod attempted to kill Christ in infancy in what he thought was an effort to save his throne.',
        'His entire public ministry was threatened by attempts to kill Him one way or another.',
      ],
      hint: "Review the lesson content for specific incidents mentioned throughout Jesus' life and ministry.",
    },
    {
      id: 'q5',
      type: 'multiple',
      question:
        'Which of the following are the two qualifications required for a person to be a witness of the resurrection of Christ? Choose the <strong>two</strong> correct answers:',
      options: [
        'They were among the 3,000 baptized on the day of Pentecost.',
        'They were with Jesus from the beginning.',
        'They knew where Jesus was born and watched Him grow up.',
        'They were empowered by the Holy Spirit.',
        'They had been persecuted by Paul for being a Christian.',
        'They listened to the apostles teaching of Jesus.',
      ],
      hint: 'Think about what qualifications the apostles had that made them credible witnesses.',
    },
    {
      id: 'q6',
      type: 'single',
      question:
        'The promised coming of the Holy Spirit on Pentecost was evidence of the resurrection of Jesus.',
      options: ['True', 'False'],
    },
    {
      id: 'q7',
      type: 'cloze_answer',
      question:
        "The Apostles' concept changed on Pentecost: They changed in ___________ and immediately began to preach Christ crucified, buried, and resurrected. They changed in __________ and became united together beyond just a brotherhood. They changed psychologically and __________ from being fearful to being courageous. They changed from men of ________ to men of ________. (These may be used to fill in the blanks: emotionally, spiritually, theology, Christ, power, the circumcision, professions, doctrine, weakness.)",
      hint: 'Look at the word bank provided and consider which words best describe different types of transformation.',
    },
    {
      id: 'q8',
      type: 'multiple',
      question:
        'Jesus made <strong>four</strong> claims that no one could take His life from Him. Identify two of those claims below:',
      options: [
        'He claimed He would die at a particular time.',
        'He claimed He would die by crucifixion.',
        'He claimed that only God had power to lay down His life.',
        'He claimed the exact Jewish festival of His death.',
      ],
    },
    {
      id: 'q9',
      type: 'multiple',
      question:
        'With regard to biblical witnessing, which of the following are true? Choose the correct answer(s):',
      options: [
        'Only the apostles could be called biblical witnesses.',
        "All believers are witnesses of Christ's resurrection.",
        'Our faith today depends on eyewitness accounts of the resurrection of Christ.',
        "A person's changed life is proof of the resurrection of Christ.",
      ],
    },
    {
      id: 'q10',
      type: 'single',
      question:
        'Demythologizing of the Gospels means to get rid of all the ___________ that occur(s) in the New Testament as pertaining to Jesus.',
      options: [
        'good deeds',
        'demon-possession',
        'supernaturalism',
        'miracles',
        'folklore',
      ],
    },
    {
      id: 'q11',
      type: 'single',
      question:
        'The promised coming of the Holy Spirit on Pentecost was evidence of what great event?',
      options: [
        'The resurrection of Jesus.',
        'The empowering of the Holy Spirit on the apostles.',
        'The end of the great tribulation.',
        'The birth of Jesus.',
        'None of the above.',
      ],
    },
    {
      id: 'q12',
      type: 'single',
      question:
        'Jesus proved His humanity by allowing His death to occur naturally through the crucifixion.',
      options: ['True', 'False'],
    },
    {
      id: 'q13',
      type: 'multiple',
      question:
        "Which four of the following are part of Paul's four-fold claim in Galatians 1:11-12 concerning the source of his gospel?",
      options: [
        'It was not after man (man-made).',
        'He had the New Testament scrolls with him.',
        'He did not receive it from man.',
        'He was not taught it by man.',
        'He was given his gospel by Ananias laying hands on him and receiving his sight.',
        'He was given his knowledge because of what happened on the road to Damascus.',
        'He received it by divine revelation of Jesus Christ.',
      ],
    },
    {
      id: 'q14',
      type: 'multiple',
      question:
        "Jesus' promise to send the Holy Spirit depended on which <strong>two</strong> of the following?",
      options: [
        'The future conduct of the apostles.',
        'His resurrection from the dead.',
        'His going back to heaven.',
        "The apostles' teaching others about the kingdom.",
        "The apostles' prayer and repentance.",
      ],
    },
    {
      id: 'q15',
      type: 'single',
      question:
        'The apostles knew without a doubt that Jesus would be raised on the third day because of their unbiased view of some Old Testament prophecies.',
      options: ['True', 'False'],
    },
    {
      id: 'q16',
      type: 'essay',
      question: 'What is something you have learned from this study?',
      hint: 'Reflect on the key themes of the resurrection and how they impact your faith today.',
    },
  ],
};

export const mockCourseData = {
  title: 'God Has Spoken',
  prerequisite: 'The Way to Life',
  description:
    'God reveals Himself and His will for you in the Bible. What does God say about Himself? Who is the Holy Spirit? How can I be "right with God"?',
  stats: {
    lessons: 8,
    topics: 55,
    hasCertificate: true,
    requiresStudyHelper: true,
  },
  progress: 100,
  lastActivityDate: '2025-02-03T12:00:00Z',
  hasAccess: true,
  lessons: [
    {
      slug: 'god-has-spoken-through-nature',
      title: 'God Has Spoken Through Nature',
      isLocked: false,
      progress: 100,
      topics: [
        {
          title: "God's Presence is Well Known",
          slug: 'gods-presence-is-well-known',
          type: 'topic' as const,
          completed: true,
        },
        {
          title: 'Seeing the Creator through Creation',
          slug: 'seeing-the-creator-through-creation',
          type: 'topic' as const,
          completed: true,
        },
        {
          title: 'Creation by Accident?',
          slug: 'creation-by-accident',
          type: 'topic' as const,
          completed: true,
        },
        {
          title: 'Every House has a Builder',
          slug: 'every-house-has-a-builder',
          type: 'topic' as const,
          completed: true,
        },
        {
          title: 'Creation Tells the Glory of God',
          slug: 'creation-tells-the-glory-of-god',
          type: 'topic' as const,
          completed: true,
        },
        {
          title: 'Give Glory and Thanks to God',
          slug: 'give-glory-and-thanks-to-god',
          type: 'topic' as const,
          completed: true,
        },
        {
          title: 'God Has Spoken Through Nature Final Quiz',
          slug: 'god-has-spoken-through-nature-final-quiz',
          type: 'quiz' as const,
          completed: true,
        },
      ],
    },
    {
      slug: 'god-has-spoken-through-the-prophets',
      title: 'God Has Spoken Through the Prophets',
      isLocked: false,
      progress: 75,
      topics: [
        {
          title: 'Nature Alone is Not Enough',
          slug: 'nature-alone-is-not-enough',
          type: 'topic' as const,
          completed: true,
        },
        {
          title: 'The God Who Speaks',
          slug: 'the-god-who-speaks',
          type: 'topic' as const,
          completed: true,
        },
        {
          title: 'God Spoke by the Prophets',
          slug: 'god-spoke-by-the-prophets',
          type: 'topic' as const,
          completed: true,
        },
        {
          title: "How Were God's True Prophets Recognized?",
          slug: 'how-were-gods-true-prophets-recognized',
          type: 'topic' as const,
          completed: true,
        },
        {
          title: 'Test for Prophets',
          slug: 'test-for-prophets',
          type: 'topic' as const,
          completed: true,
        },
        {
          title: 'Learning from the Prophets',
          slug: 'learning-from-the-prophets',
          type: 'topic' as const,
          completed: false,
        },
        {
          title: 'God Has Spoken Through the Prophets Final Quiz',
          slug: 'god-has-spoken-through-the-prophets-final-quiz',
          type: 'quiz' as const,
          completed: false,
        },
      ],
    },
    {
      slug: 'god-has-spoken-through-a-prophet-like-moses-2',
      title: 'God Has Spoken Through a Prophet Like Moses',
      isLocked: false,
      progress: 30,
      topics: [
        {
          title: "God's Glory Too Great for Man",
          slug: 'gods-glory-too-great-for-man',
          type: 'topic' as const,
        },
        {
          title: 'We Need a Mediator, Not Mediums',
          slug: 'we-need-a-mediator-not-mediums',
          type: 'topic' as const,
        },
        {
          title: 'No Prophet Like Moses',
          slug: 'no-prophet-like-moses',
          type: 'topic' as const,
        },
        {
          title: 'Promises of "The Messiah"',
          slug: 'promises-of-the-messiah',
          type: 'topic' as const,
        },
        {
          title: 'Is Jesus that Messiah?',
          slug: 'is-jesus-that-messiah',
          type: 'topic' as const,
        },
        {
          title: 'The Greatest Sign',
          slug: 'the-greatest-sign',
          type: 'topic' as const,
        },
        {
          title: 'God Has Spoken Through a Prophet Like Moses Final Quiz',
          slug: 'god-has-spoken-through-a-prophet-like-moses-final-quiz',
          type: 'quiz' as const,
        },
      ],
    },
    {
      slug: 'only-one-god-has-spoken',
      title: 'Only One God Has Spoken',
      isLocked: false,
      progress: 0,
      topics: [
        {
          title: 'Confirmed by Jesus',
          slug: 'confirmed-by-jesus',
          type: 'topic' as const,
        },
        {
          title: 'Can We Love Anyone Else?',
          slug: 'can-we-love-anyone-else',
          type: 'topic' as const,
        },
        {
          title: 'What, Then, Is Love Divided?',
          slug: 'what-then-is-love-divided',
          type: 'topic' as const,
        },
        {
          title: 'The Name of the One God',
          slug: 'the-name-of-the-one-god',
          type: 'topic' as const,
        },
        {
          title: 'No Other Gods',
          slug: 'no-other-gods',
          type: 'topic' as const,
        },
        {
          title: 'God is Spirit',
          slug: 'god-is-spirit',
          type: 'topic' as const,
        },
        {
          title: 'Does God Have Hands and Eyes?',
          slug: 'does-god-have-hands-and-eyes',
          type: 'topic' as const,
        },
        {
          title: 'The Holy Spirit',
          slug: 'the-holy-spirit',
          type: 'topic' as const,
        },
        {
          title: 'Only One God Has Spoken Final Quiz',
          slug: 'only-one-god-has-spoken-final-quiz',
          type: 'quiz' as const,
        },
      ],
    },
    {
      slug: 'god-has-spoken-through-his-writings',
      title: 'God Has Spoken Through His Writings',
      isLocked: true,
      progress: 0,
      topics: [
        {
          title: 'All Scripture is Inspired',
          slug: 'all-scripture-is-inspired',
          type: 'topic' as const,
        },
        {
          title: "God's Main Way of Speaking",
          slug: 'gods-main-way-of-speaking',
          type: 'topic' as const,
        },
        {
          title: 'God Has Spoken in Two Parts',
          slug: 'god-has-spoken-in-two-parts',
          type: 'topic' as const,
        },
        {
          title: 'There Has Been a Change of the Law',
          slug: 'there-has-been-a-change-of-the-law',
          type: 'topic' as const,
        },
        {
          title: 'Other Laws of Moses',
          slug: 'other-laws-of-moses',
          type: 'topic' as const,
        },
        {
          title: 'The Covenant with Israel',
          slug: 'the-covenant-with-israel',
          type: 'topic' as const,
        },
        {
          title: 'The New Covenant Replaced the Old',
          slug: 'the-new-covenant-replaced-the-old',
          type: 'topic' as const,
        },
        {
          title: 'The New Foundation',
          slug: 'the-new-foundation',
          type: 'topic' as const,
        },
        {
          title: 'God Has Spoken Through His Writings Final Quiz',
          slug: 'god-has-spoken-through-his-writings-final-quiz',
          type: 'quiz' as const,
        },
      ],
    },
    {
      slug: 'god-has-spoken-of-his-enemy',
      title: 'God Has Spoken of His Enemy',
      topics: [
        {
          title: 'The Father of Lies',
          slug: 'the-father-of-lies',
          type: 'topic' as const,
        },
        {
          title: 'War in Heaven ... Woe to the Earth!',
          slug: 'war-in-heaven-woe-to-the-earth',
          type: 'topic' as const,
        },
        {
          title: 'A Struggle that Calls for Choices',
          slug: 'a-struggle-that-calls-for-choices',
          type: 'topic' as const,
        },
        {
          title: 'A Struggle Over Worship',
          slug: 'a-struggle-over-worship',
          type: 'topic' as const,
        },
        {
          title: 'Satan Attacks the Word of God',
          slug: 'satan-attacks-the-word-of-god',
          type: 'topic' as const,
        },
        {
          title: 'The Good News of Jesus Christ',
          slug: 'the-good-news-of-jesus-christ',
          type: 'topic' as const,
        },
        {
          title: 'God Has Spoken of His Enemy Final Quiz',
          slug: 'god-has-spoken-of-his-enemy-final-quiz',
          type: 'quiz' as const,
        },
      ],
    },
    {
      slug: 'god-has-spoken-of-judgment',
      title: 'God Has Spoken of Judgment',
      topics: [
        {
          title: '"The Day of Judgment"',
          slug: 'the-day-of-judgment',
          type: 'topic' as const,
        },
        {
          title: 'Why God is Angry',
          slug: 'why-god-is-angry',
          type: 'topic' as const,
        },
        {
          title: 'Making a More Pleasing God',
          slug: 'making-a-more-pleasing-god',
          type: 'topic' as const,
        },
        {
          title: 'The Worship of Demons',
          slug: 'the-worship-of-demons',
          type: 'topic' as const,
        },
        {
          title: 'Man as His Own God',
          slug: 'man-as-his-own-god',
          type: 'topic' as const,
        },
        {
          title: "God Made in Man's Image",
          slug: 'god-made-in-mans-image',
          type: 'topic' as const,
        },
        {
          title: 'Seriously Seeking God',
          slug: 'seriously-seeking-god',
          type: 'topic' as const,
        },
        {
          title: 'God Has Spoken of Judgment Final Quiz',
          slug: 'god-has-spoken-of-judgment-final-quiz',
          type: 'quiz' as const,
        },
      ],
    },
    {
      slug: 'god-has-spoken-of-mercy',
      title: 'God Has Spoken of Mercy',
      topics: [
        {
          title: 'Love from the Beginning',
          slug: 'love-from-the-beginning',
          type: 'topic' as const,
        },
        {
          title: "Love's Gift of Family and Friendship",
          slug: 'loves-gift-of-family-and-friendship',
          type: 'topic' as const,
        },
        {
          title: 'Anger Could Not Hide Love',
          slug: 'anger-could-not-hide-love',
          type: 'topic' as const,
        },
        {
          title: 'Why do we Suffer in this World?',
          slug: 'why-do-we-suffer-in-this-world',
          type: 'topic' as const,
        },
        {
          title: 'God Uses Good Times and Bad Times',
          slug: 'god-uses-good-times-and-bad-times',
          type: 'topic' as const,
        },
        {
          title: 'The Lord Disciplines Those He Loves',
          slug: 'the-lord-disciplines-those-he-loves',
          type: 'topic' as const,
        },
        {
          title: "Is Hell a Part of God's Plan of Love?",
          slug: 'is-hell-a-part-of-gods-plan-of-love',
          type: 'topic' as const,
        },
        {
          title: "God's Greatest Gift of Love",
          slug: 'gods-greatest-gift-of-love',
          type: 'topic' as const,
        },
        {
          title: 'God Has Spoken of Mercy Final Quiz',
          slug: 'god-has-spoken-of-mercy-final-quiz',
          type: 'quiz' as const,
        },
      ],
    },
  ],
};

export function getMockTopicHtmlContent(topicSlug: string): string {
  return `
    <img src='https://picsum.photos/seed/${topicSlug}/700/300' alt='Random illustration' />
   <blockquote>
      In the beginning God created the heavens and the earth (Genesis 1:1).
    </blockquote>

    <p>
      With these words the Bible opens the history of our world. It does not
      try to prove that God exists. From the very beginning God already is,
      and He is already active. The writers of the Bible never doubt or
      question God's existence. Nor do they go into long arguments to show
      to others that God is real. Why is this?
    </p>

    <h3>God's Presence Is Well Known</h3>

    <blockquote>"No one has ever seen God" (John 1:18).</blockquote>

    <p>
      The fact that God is not directly seen does not have to lead to doubt.
    </p>

    <p>
      The wind is unseen. Does anyone really doubt that wind exists? We are
      sure it exists because we see the results of its blowing. Though God
      is invisible, we know He is there because of the results of His
      powerful work. The world around us, called "nature," is one of those
      results (Genesis 1:1). With other results of God's work, nature speaks
      clearly of its Creator.
    </p>

    <p>
      People through the ages, and all over the world, have come to the same
      conclusion: Creation points to an amazing Creator. Rulers who have
      tried to make people deny God have ended in failure. When those rulers
      fall, their people are seeking God more than ever.
    </p>
  `;
}

export function getMockTopicThoughtQuestions(topicSlug: string) {
  const thoughtQuestionsMap: Record<
    string,
    Array<{ id: string; question: string }>
  > = {
    'gods-presence-is-well-known': [
      {
        id: 'tq-1',
        question: 'Who are the "called" and "chosen?"',
      },
      {
        id: 'tq-2',
        question: 'Who are "God\'s Family?" (1 Timothy 3:15)',
      },
    ],
    'seeing-the-creator-through-creation': [
      {
        id: 'tq-3',
        question:
          "Where in Scripture is God's plan for reaching out - through His family - to every person on earth?",
      },
    ],
    'creation-by-accident': [
      {
        id: 'tq-4',
        question:
          'Many are so busy that they forget their most pressing appointment -- death. They never see that life can end at any moment. How have you seen someone live like there will be no end to their life?',
      },
      {
        id: 'tq-5',
        question: `Are you willing for Jesus to be your only Savior and the very center of your life?
If you answered "No," you may wish to write a note telling who or what gives you hope in life and hope in death.`,
      },
      {
        id: 'tq-6',
        question:
          "Why is Revelation important for our understanding of God's family in Ephesus? (Revelation 1:11; 2:1-7)",
      },
    ],
  };

  return thoughtQuestionsMap[topicSlug] || [];
}

export const mockUserData = {
  id: 123,
  email: 'test@gmail.com',
  congregation: 'Place Name Church of Christ',
  lastLogin: '2025-10-31T12:00:00Z',
  lastActivity: '2025-11-17T12:00:00Z',
  lastActivityLiteapp: '2025-10-31T12:00:00Z',
  lastActivityFullapp: '2025-10-31T12:00:00Z',
  registeredAt: '2021-08-09T12:00:00Z',
  adoptionDetails: 'n/a',
  firstName: 'John',
  lastName: 'Doe',
  birthdate: { day: '01', month: 'January', year: '2000' },
  gender: 'Male',
  country: 'United States',
  address: '',
  address2: '',
  city: 'Chicago',
  state: 'Illinois',
  postalCode: '60601',
  phoneNumber: '3125551234',
  languages: ['en', 'fr', 'es', 'pt-br'],
  whatsappNumber: '',
  publicProfile: true,
  studyHelperBoard: true,
  studyHelperPreferences: ['Web', 'LiteApp', 'Postal'],
  maxStudents: '',
};

export const mockThreads = [
  {
    id: 1,
    name: 'Olivia Carter',
    avatarUrl: 'https://randomuser.me/api/portraits/women/27.jpg',
    preview: 'You: See you soon!',
    date: 'Nov 2',
    unread: true,
    userId: 2990407,
  },
  {
    id: 2,
    name: 'Liam Johnson',
    avatarUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
    preview: 'Thanks for the update.',
    date: 'Oct 28',
    unread: false,
    userId: 3100001,
  },
  {
    id: 3,
    name: 'Emma Lee',
    avatarUrl: 'https://randomuser.me/api/portraits/women/45.jpg',
    preview: 'You: Got it!',
    date: 'Oct 15',
    unread: false,
    userId: 3200002,
  },
  {
    id: 4,
    name: 'Noah Smith',
    avatarUrl: 'https://randomuser.me/api/portraits/men/18.jpg',
    preview: 'Let me know.',
    date: 'Sep 30',
    unread: false,
    userId: 3300003,
  },
  {
    id: 5,
    name: 'Ava Martinez',
    avatarUrl: 'https://randomuser.me/api/portraits/women/36.jpg',
    preview: 'You: Will do!',
    date: 'Sep 22',
    unread: false,
    userId: 1234567,
  },
  {
    id: 6,
    name: 'Mason Brown',
    avatarUrl: 'https://randomuser.me/api/portraits/men/41.jpg',
    preview: 'Hello!',
    date: 'Sep 10',
    unread: false,
    userId: 3400004,
  },
  {
    id: 7,
    name: 'Sophia Wilson',
    avatarUrl: 'https://randomuser.me/api/portraits/women/52.jpg',
    preview: 'You: Thank you!',
    date: 'Aug 29',
    unread: false,
    userId: 3500005,
  },
  {
    id: 8,
    name: 'James Davis',
    avatarUrl: 'https://randomuser.me/api/portraits/men/53.jpg',
    preview: 'See you tomorrow.',
    date: 'Aug 18',
    unread: false,
    userId: 3600006,
  },
  {
    id: 9,
    name: 'Mia Clark',
    avatarUrl: 'https://randomuser.me/api/portraits/women/60.jpg',
    preview: 'You: Great!',
    date: 'Aug 2',
    unread: false,
    userId: 3700007,
  },
  {
    id: 10,
    name: 'Benjamin Evans',
    avatarUrl: 'https://randomuser.me/api/portraits/men/65.jpg',
    preview: "Let's catch up soon.",
    date: 'Jul 25',
    unread: false,
    userId: 3800008,
  },
  {
    id: 11,
    name: 'Charlotte King',
    avatarUrl: 'https://randomuser.me/api/portraits/women/68.jpg',
    preview: 'You: Absolutely!',
    date: 'Jul 10',
    unread: false,
    userId: 3900009,
  },
];

export const mockComposeUsers: Record<
  number,
  { name: string; avatarUrl: string | null }
> = {
  1234567: {
    name: 'Alice Johnson',
    avatarUrl: null,
  },
  2345678: {
    name: 'Bob Smith',
    avatarUrl: null,
  },
  3456789: {
    name: 'Carlos Rivera',
    avatarUrl: null,
  },
  4567890: {
    name: 'Dana Lee',
    avatarUrl: null,
  },
  5678901: {
    name: 'Elena Torres',
    avatarUrl: null,
  },
};

export const mockUserSidebarData = {
  userId: 12345,
  joinedDate: 'January 2023',
  accountType: 'study_helper',
  groupCount: 2,
};

export const mockMessagesByThread: Record<
  number,
  Array<{
    id: number;
    sender: string;
    avatarUrl: string;
    content: string;
    timestamp: string;
    isCurrentUser: boolean;
  }>
> = {
  1: [
    {
      id: 1,
      sender: 'Olivia Carter',
      avatarUrl: 'https://randomuser.me/api/portraits/women/27.jpg',
      content:
        'Hey, are we still on for lunch tomorrow? I was hoping we could have a longer conversation about what we have been studying. I was confused about some of the words in the verses we discussed.',
      timestamp: '2 days ago',
      isCurrentUser: false,
    },
    {
      id: 2,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: 'Yes! See you soon!',
      timestamp: '2 days ago',
      isCurrentUser: true,
    },
    {
      id: 3,
      sender: 'Olivia Carter',
      avatarUrl: 'https://randomuser.me/api/portraits/women/27.jpg',
      content: 'Awesome, looking forward to it.',
      timestamp: '1 day ago',
      isCurrentUser: false,
    },
  ],
  2: [
    {
      id: 1,
      sender: 'Liam Johnson',
      avatarUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
      content: 'Thanks for the update.',
      timestamp: '5 days ago',
      isCurrentUser: false,
    },
    {
      id: 2,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: 'No problem!',
      timestamp: '5 days ago',
      isCurrentUser: true,
    },
    {
      id: 3,
      sender: 'Liam Johnson',
      avatarUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
      content: 'Let me know if you need anything else.',
      timestamp: '4 days ago',
      isCurrentUser: false,
    },
  ],
  3: [
    {
      id: 1,
      sender: 'Emma Lee',
      avatarUrl: 'https://randomuser.me/api/portraits/women/45.jpg',
      content: 'Did you get the documents?',
      timestamp: '2 weeks ago',
      isCurrentUser: false,
    },
    {
      id: 2,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: 'Got it!',
      timestamp: '2 weeks ago',
      isCurrentUser: true,
    },
  ],
  4: [
    {
      id: 1,
      sender: 'Noah Smith',
      avatarUrl: 'https://randomuser.me/api/portraits/men/18.jpg',
      content: "Let me know when you're free.",
      timestamp: '1 month ago',
      isCurrentUser: false,
    },
    {
      id: 2,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: 'Will do!',
      timestamp: '1 month ago',
      isCurrentUser: true,
    },
    {
      id: 3,
      sender: 'Noah Smith',
      avatarUrl: 'https://randomuser.me/api/portraits/men/18.jpg',
      content: 'Thanks!',
      timestamp: '3 weeks ago',
      isCurrentUser: false,
    },
  ],
  5: [
    {
      id: 1,
      sender: 'Ava Martinez',
      avatarUrl: 'https://randomuser.me/api/portraits/women/36.jpg',
      content: 'Can you send the file?',
      timestamp: '2 months ago',
      isCurrentUser: false,
    },
    {
      id: 2,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: 'Will do!',
      timestamp: '2 months ago',
      isCurrentUser: true,
    },
  ],
  6: [
    {
      id: 1,
      sender: 'Mason Brown',
      avatarUrl: 'https://randomuser.me/api/portraits/men/41.jpg',
      content: 'Hello!',
      timestamp: '2 months ago',
      isCurrentUser: false,
    },
    {
      id: 2,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: 'Hi Mason!',
      timestamp: '2 months ago',
      isCurrentUser: true,
    },
    {
      id: 3,
      sender: 'Mason Brown',
      avatarUrl: 'https://randomuser.me/api/portraits/men/41.jpg',
      content: 'How are you?',
      timestamp: '2 months ago',
      isCurrentUser: false,
    },
    {
      id: 4,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: 'Doing well, thanks!',
      timestamp: '2 months ago',
      isCurrentUser: true,
    },
  ],
  7: [
    {
      id: 1,
      sender: 'Sophia Wilson',
      avatarUrl: 'https://randomuser.me/api/portraits/women/52.jpg',
      content: 'Thank you!',
      timestamp: '3 months ago',
      isCurrentUser: false,
    },
    {
      id: 2,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: "You're welcome!",
      timestamp: '3 months ago',
      isCurrentUser: true,
    },
  ],
  8: [
    {
      id: 1,
      sender: 'James Davis',
      avatarUrl: 'https://randomuser.me/api/portraits/men/53.jpg',
      content: 'See you tomorrow.',
      timestamp: '4 months ago',
      isCurrentUser: false,
    },
    {
      id: 2,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: 'Looking forward to it!',
      timestamp: '4 months ago',
      isCurrentUser: true,
    },
  ],
  9: [
    {
      id: 1,
      sender: 'Mia Clark',
      avatarUrl: 'https://randomuser.me/api/portraits/women/60.jpg',
      content: 'Great!',
      timestamp: '4 months ago',
      isCurrentUser: false,
    },
    {
      id: 2,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: 'Thanks Mia!',
      timestamp: '4 months ago',
      isCurrentUser: true,
    },
    {
      id: 3,
      sender: 'Mia Clark',
      avatarUrl: 'https://randomuser.me/api/portraits/women/60.jpg',
      content: 'Talk soon.',
      timestamp: '3 months ago',
      isCurrentUser: false,
    },
  ],
  10: [
    {
      id: 1,
      sender: 'Benjamin Evans',
      avatarUrl: 'https://randomuser.me/api/portraits/men/65.jpg',
      content: "Let's catch up soon.",
      timestamp: '2 months ago',
      isCurrentUser: false,
    },
    {
      id: 2,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: 'Sounds good, Ben!',
      timestamp: '2 months ago',
      isCurrentUser: true,
    },
    {
      id: 3,
      sender: 'Benjamin Evans',
      avatarUrl: 'https://randomuser.me/api/portraits/men/65.jpg',
      content: "Let me know when you're free.",
      timestamp: '1 month ago',
      isCurrentUser: false,
    },
  ],
  11: [
    {
      id: 1,
      sender: 'Charlotte King',
      avatarUrl: 'https://randomuser.me/api/portraits/women/68.jpg',
      content: 'Absolutely!',
      timestamp: '1 month ago',
      isCurrentUser: false,
    },
    {
      id: 2,
      sender: 'You',
      avatarUrl: 'https://randomuser.me/api/portraits/women/85.jpg',
      content: "Let's plan for next week.",
      timestamp: '1 month ago',
      isCurrentUser: true,
    },
    {
      id: 3,
      sender: 'Charlotte King',
      avatarUrl: 'https://randomuser.me/api/portraits/women/68.jpg',
      content: "Perfect, I'll check my calendar.",
      timestamp: '3 weeks ago',
      isCurrentUser: false,
    },
  ],
};

export const tutorialsData = [
  {
    slug: 'changing-your-email',
    title: 'Test - changing your email',
    date: '2021-11-08T12:00:00Z',
    description:
      'Sometimes it is necessary to change the email address associated with your account. You can do this yourself by going to your Account/Login Information.',
    content: `
      <h2>How to Change Your Email Address</h2>
      <p>Sometimes it is necessary to change the email address associated with your account. You can do this yourself by going to your Account/Login Information.</p>
      <h3>Step 1: Navigate to Account Settings</h3>
      <p>Click on your profile icon in the top right corner and select "Account Settings" from the dropdown menu.</p>
      <h3>Step 2: Update Your Email</h3>
      <ol>
        <li>Find the "Login Information" section</li>
        <li>Click on the "Edit" button next to your current email address</li>
        <li>Enter your new email address</li>
        <li>Confirm your password</li>
        <li>Click "Save Changes"</li>
      </ol>
      <h3>Step 3: Verify Your New Email</h3>
      <p>You will receive a verification email at your new email address. Click the link in that email to complete the process.</p>
      <div class="note">
        <strong>Note:</strong> Make sure you have access to the new email address before making the change.
      </div>
    `,
  },
  // --- Extra mock tutorials for infinite scroll demo ---
  ...Array.from({ length: 20 }, (_, i) => ({
    slug: `mock-tutorial-${i + 1}`,
    title: `Mock Tutorial ${i + 1}`,
    date: `2022-01-${(i % 28) + 1}`,
    description: `This is a mock tutorial for infinite scroll testing. Tutorial #${i + 1}.`,
    content: `<h2>Mock Tutorial ${i + 1}</h2><p>This is the content for mock tutorial #${i + 1}.</p>`,
  })),
  {
    slug: 'teaching-postal-students',
    title: 'Teaching Postal Students',
    date: '2021-04-01T12:00:00Z',
    description:
      'Teaching Postal Students Overview Postal students receive all information through postal mail. If there is a WBS postal program at your congregation, check with your...',
    content: `
      <h2>Teaching Postal Students Overview</h2>
      <p>Postal students receive all information through postal mail. If there is a WBS postal program at your congregation, check with your congregation coordinator for specific procedures.</p>

      <h3>Key Differences</h3>
      <ul>
        <li>All communication is done via postal mail</li>
        <li>Response times are typically longer</li>
        <li>You'll need to manually grade and mail back lessons</li>
        <li>Print materials must be managed carefully</li>
      </ul>

      <h3>Getting Started</h3>
      <p>When you receive a new postal student assignment:</p>
      <ol>
        <li>Review the student's information in the Student Board</li>
        <li>Prepare the first lesson materials</li>
        <li>Include a personal welcome letter</li>
        <li>Mail the package with appropriate postage</li>
      </ol>

      <h3>Best Practices</h3>
      <p>Keep detailed records of what you send and when. This helps track student progress and ensures nothing gets lost in the mail.</p>
    `,
  },
  {
    slug: 'test-tutorial',
    title: 'adfasdf',
    date: '2021-03-01T12:00:00Z',
    description: 'adfasdfad',
    content: '<p>This is a test tutorial with minimal content.</p>',
  },
  {
    slug: 'adding-student-manually',
    title: 'Adding a Student Manually',
    date: '2014-10-08T12:00:00Z',
    description:
      'The My Students page is where you go when you want to manually add a student that you would like to teach. You might want...',
    content: `
      <h2>Adding a Student Manually</h2>
      <p>The My Students page is where you go when you want to manually add a student that you would like to teach. You might want to do this if someone you know personally wants to study with you.</p>
      <h3>Steps to Add a Student</h3>
      <ol>
        <li>Navigate to the "My Students" page</li>
        <li>Click the "Add Student" button</li>
        <li>Fill in the student's information (name, email, language preference)</li>
        <li>Select the course they want to begin with</li>
        <li>Click "Submit" to add them to your student list</li>
      </ol>
    `,
  },
  {
    slug: 'adopting-followup-requests',
    title: 'Adopting Followup Requ...',
    date: '2014-10-08T12:00:00Z',
    description:
      'As a Followup Partner, it is important that you know how to adopt a student for followup. To adopt a student for Followup: 1. Click...',
    content: `
      <h2>Adopting Follow-up Requests</h2>
      <p>As a Follow-up Partner, it is important that you know how to adopt a student for follow-up.</p>
      <h3>To adopt a student for Follow-up:</h3>
      <ol>
        <li>Click on the Follow-up tab in the main navigation</li>
        <li>Browse available follow-up requests</li>
        <li>Click "Adopt" on a request that matches your capacity</li>
        <li>Begin communication with the student promptly</li>
      </ol>
    `,
  },
  {
    slug: 'avoiding-scams',
    title: 'Suggestions for Avoiding Scams',
    date: '2013-02-18T12:00:00Z',
    description:
      'Guidelines and best practices for avoiding scams and protecting your privacy as a WBS Study Helper.',
    content: `
      <p>
        <p>“I am sending you out like sheep among wolves. Therefore be as shrewd as snakes and as innocent as doves” (Matthew 10:16).</p>
      </p>
      <p><strong>Please note these rules:</strong></p>
      <ol>
        <li>WBS Study Helpers are not obligated to send Bibles, money or anything material to their Students.</li>
        <li>WBS Online Study Helpers are not obligated to give ANY contact information to Students, including email address, Skype username, Facebook, Twitter, LinkedIn, postal address, or phone number.</li>
        <li>WBS Postal Study Helpers might give their mailing address to Students, but they are not required to give any other contact information. If you are uncomfortable giving out your personal address, you might consider using your congregation’s mailing address.</li>
        <li>WBS does NOT scan messages because files can’t be uploaded to the website. However, LiteApp students can use WhatsApp to communicate with their Study Helper and can send attachments that will appear in the Study Helper’s Messages. Use caution if you see a file or if a Student asks you to click a link to another website. Never submit any personal information through a link given to you by a Student. Never install any software through a link given to you by a Student. Please use caution when a Student asks you to send him/her something material, even of little value.</li>
        <li>WBS Students come from all over the globe. We find Students through online advertising, word-of-mouth, flyers, posters, business cards, Facebook, and anything else we can think to use. We cast a wide net and do nothing to pre-qualify these Students for study. This is on purpose. We are scattering seeds as far and wide as we are capable of doing.</li>
      </ol>
      <p>The majority of Students are here for the right reasons, however, sometimes we get Students who aren’t in the program for the right reasons. Sometimes we get Students who want to take advantage of the kindness of Christians. Even worse, there are some Students who are just looking to scam Christians for everything they can get.</p>
      <p>Our goal is to share our faith. We want to avoid identity fraud and other scams. Stay shrewd.</p>
      <p>If you suspect ill motives, or if you have any tips we can add to this article, please contact us at <a href="mailto:help@worldbibleschool.net">help@worldbibleschool.net</a>.</p>
    `,
  },
  {
    slug: 'followup-reporting',
    title: 'Followup Reporting and ...',
    date: '2014-10-14T12:00:00Z',
    description:
      'After adopting a followup request, you will need to know how to handle and provide updates on the request. To view your Followup Students: 1...',
    content: `
      <h2>Follow-up Reporting</h2>
      <p>After adopting a follow-up request, you will need to know how to handle and provide updates on the request.</p>
      <h3>To view your Follow-up Students:</h3>
      <ol>
        <li>Go to the Follow-up section</li>
        <li>Click on "My Follow-up Students"</li>
        <li>You'll see a list of all students assigned to you</li>
      </ol>
      <h3>Providing Updates</h3>
      <p>Regular updates are essential for tracking student progress and coordinating with other study helpers.</p>
    `,
  },
  {
    slug: 'bible-requests',
    title: 'Bible Requests',
    date: '2013-03-28T12:00:00Z',
    description:
      'WBS does not recommend sending items to students other than the WBS courses. WBS teachers are under no obligation to send Bibles or printed certificates...',
    content: `
      <h2>Bible Requests</h2>
      <p>WBS does not recommend sending items to students other than the WBS courses. WBS teachers are under no obligation to send Bibles or printed certificates to students.</p>
      <h3>Why We Have This Policy</h3>
      <ul>
        <li>It helps maintain appropriate boundaries</li>
        <li>It prevents potential scams</li>
        <li>It keeps the focus on Bible study</li>
        <li>It protects teachers from being taken advantage of</li>
      </ul>
      <p>If a student expresses a genuine need for a Bible, please contact your coordinator who can help arrange appropriate resources.</p>
    `,
  },
  {
    slug: 'assigning-certificate',
    title: 'Assigning a Certificate',
    date: '2014-10-08T12:00:00Z',
    description:
      'The Assignments page is where you go when you want to assign a certificate to a student. You will want to do this when your...',
    content: `
      <h2>Assigning a Certificate</h2>
      <p>The Assignments page is where you go when you want to assign a certificate to a student. You will want to do this when your student has completed all the required coursework.</p>
      <h3>Steps to Assign a Certificate</h3>
      <ol>
        <li>Go to your student's profile</li>
        <li>Navigate to the "Assignments" tab</li>
        <li>Verify all required courses are completed</li>
        <li>Click "Assign Certificate"</li>
        <li>Choose the certificate type</li>
        <li>The student will receive notification</li>
      </ol>
    `,
  },
  {
    slug: 'building-strong-study-habits',
    title: 'Building Strong Study Habits',
    date: '2014-05-05T12:00:00Z',
    description:
      'Practical tips and strategies to help you and your students develop consistent, effective study habits. Learn the best ways to stay engaged and grow spiritually.',
    content: `
      <h2>Building Strong Study Habits</h2>
      <p>Developing strong study habits is essential for anyone seeking to grow in knowledge and faith. Here are some practical tips to help you and your students stay consistent and engaged in your studies.</p>
      <h3>Tips for Effective Study</h3>
      <ul>
        <li>Set aside a regular time and place for study</li>
        <li>Minimize distractions (turn off notifications, find a quiet spot)</li>
        <li>Set specific goals for each study session</li>
        <li>Take notes and highlight key points</li>
        <li>Review and reflect on what you’ve learned</li>
        <li>Pray for understanding and application</li>
      </ul>
      <h3>Encouraging Your Students</h3>
      <p>Encourage your students to share their study routines and challenges. Celebrate their progress and help them overcome obstacles to consistent study.</p>
    `,
  },
];

export const newsData = [
  {
    slug: 'new-study-materials-released',
    title: 'New Study Materials Released for 2024',
    date: '2024-12-15T12:00:00Z',
    description:
      'We are excited to announce the release of new study materials designed to help students grow in their faith journey.',
    imageUrl: 'https://picsum.photos/seed/news1/400/250',
    content: `
      <h2>New Study Materials Released for 2024</h2>
      <p>We are excited to announce the release of new study materials designed to help students grow in their faith journey. These materials have been carefully crafted by our team of biblical scholars and educators.</p>

      <h3>What's New</h3>
      <ul>
        <li>Updated course content with modern examples</li>
        <li>Interactive study guides</li>
        <li>Video supplementary materials</li>
        <li>Enhanced discussion questions</li>
      </ul>

      <p>All materials are available now in the course library. We encourage study helpers to review these new resources and incorporate them into your teaching.</p>
    `,
  },
  {
    slug: 'daily-devotional-walking-with-god',
    title: 'Daily Devotional: Walking with God',
    date: '2024-12-10T12:00:00Z',
    description:
      "Join us in this week's devotional as we explore what it means to walk daily with God and grow in our relationship with Him.",
    imageUrl: 'https://picsum.photos/seed/news2/400/250',
    content: `
      <h2>Walking with God Daily</h2>
      <blockquote>
        <p>Enoch walked faithfully with God; then he was no more, because God took him away.</p>
        <cite>– Genesis 5:24</cite>
      </blockquote>

      <p>What does it mean to walk with God? This week, let's meditate on the example of Enoch and consider how we can develop a closer walk with our Creator.</p>

      <h3>Reflection Questions</h3>
      <ul>
        <li>How do I make time for God in my daily routine?</li>
        <li>What habits help me stay connected to Him?</li>
        <li>Where can I grow in my walk with God?</li>
      </ul>
    `,
  },
  {
    slug: 'coordinator-corner-december-2024',
    title: "Coordinator's Corner: Year-End Tips",
    date: '2024-12-05T12:00:00Z',
    description:
      'Essential tips for coordinators as we wrap up 2024 and prepare for a successful 2025 ministry year.',
    imageUrl: 'https://picsum.photos/seed/news3/400/250',
    content: `
      <h2>Year-End Tips for Coordinators</h2>
      <p>As we approach the end of 2024, here are some important reminders for coordinators to ensure a smooth transition into the new year.</p>

      <h3>Action Items</h3>
      <ol>
        <li>Review student assignments and completion rates</li>
        <li>Check in with study helpers about their availability</li>
        <li>Update group information and roles</li>
        <li>Plan for Q1 2025 recruiting efforts</li>
      </ol>
    `,
  },
  {
    slug: 'student-success-story-maria',
    title: "Success Story: Maria's Journey to Baptism",
    date: '2024-11-28T12:00:00Z',
    description:
      "Read about Maria's inspiring journey from first contact to baptism and how her study helper made a difference.",
    imageUrl: 'https://picsum.photos/seed/news4/400/250',
    content: `
      <h2>Maria's Journey to Baptism</h2>
      <p>We are thrilled to share Maria's inspiring story of faith. After completing her Bible study courses and building a strong relationship with her study helper, Maria was baptized last month.</p>

      <h3>From Her Study Helper</h3>
      <blockquote>
        <p>Watching Maria grow in her faith has been one of the most rewarding experiences of my life. She asked thoughtful questions and truly sought to understand God's word.</p>
      </blockquote>

      <p>Stories like Maria's remind us why we do this work. Every student represents a precious soul seeking truth.</p>
    `,
  },
  {
    slug: 'new-mobile-app-features',
    title: 'New Mobile App Features Now Available',
    date: '2024-11-20T12:00:00Z',
    description:
      'Check out the latest features added to the WBS mobile app, making it easier than ever to stay connected with your students.',
    imageUrl: 'https://picsum.photos/seed/news5/400/250',
    content: `
      <h2>New Mobile App Features</h2>
      <p>We've been working hard to improve your mobile experience. Here are the latest features now available in the WBS mobile app.</p>

      <h3>What's New</h3>
      <ul>
        <li>Push notifications for student activity</li>
        <li>Offline mode for grading</li>
        <li>Quick reply templates</li>
        <li>Enhanced student dashboard</li>
      </ul>

      <p>Update your app today to access these new features!</p>
    `,
  },
  {
    slug: 'call-to-action-general-outreach',
    title: 'Action!Campaign',
    date: '2024-11-15T12:00:00Z',
    description: 'Join our outreach campaign to connect with more students.',
    imageUrl: 'https://picsum.photos/seed/news6/400/250',
    content: `
      <h2>Outreach Campaign</h2>
      <p>Now is a great time to reach out to students who may be searching for meaning or support. Join our special outreach campaign to make a difference!</p>

      <h3>How You Can Participate</h3>
      <ol>
        <li>Send encouraging messages to your students</li>
        <li>Adopt a waiting student</li>
        <li>Share your testimony</li>
        <li>Invite friends to become study helpers</li>
      </ol>

      <div class="note">
        <strong>Goal:</strong> Connect with 1,000 students through this campaign!
      </div>
    `,
  },
  {
    slug: 'course-update-gospel-of-john',
    title: 'Course Update: Gospel of John Series',
    date: '2024-11-10T12:00:00Z',
    description:
      'Learn about the updates to our popular Gospel of John series, including new lessons and study questions.',
    imageUrl: 'https://picsum.photos/seed/news7/400/250',
    content: `
      <h2>Gospel of John Series Update</h2>
      <p>We've made significant updates to our Gospel of John series based on feedback from study helpers and students.</p>

      <h3>Updates Include</h3>
      <ul>
        <li>Three new lessons focusing on key miracles</li>
        <li>Enhanced study questions</li>
        <li>Cross-reference guides</li>
        <li>Video introductions for each chapter</li>
      </ul>
    `,
  },
  {
    slug: 'platform-statistics-q4-2024',
    title: 'Q4 2024 Platform Statistics',
    date: '2024-10-30T12:00:00Z',
    description:
      'Review the impressive growth and impact statistics from Q4 2024 across the WBS platform.',
    imageUrl: 'https://picsum.photos/seed/news8/400/250',
    content: `
      <h2>Q4 2024 Platform Statistics</h2>
      <p>We're excited to share the growth and impact of our ministry in Q4 2024.</p>

      <h3>By the Numbers</h3>
      <ul>
        <li>12,450 active students</li>
        <li>3,200 study helpers</li>
        <li>450 baptisms reported</li>
        <li>89% student satisfaction rate</li>
      </ul>

      <p>Thank you for being part of this incredible ministry!</p>
    `,
  },
  {
    slug: 'system-maintenance-update',
    title: 'System Maintenance Scheduled for December',
    date: '2024-10-25T12:00:00Z',
    description:
      'Important information about scheduled system maintenance and expected downtime.',
    imageUrl: 'https://picsum.photos/seed/news9/400/250',
    content: `
      <h2>Scheduled System Maintenance</h2>
      <p>We will be performing system maintenance on 2024-12-20, from 2:00 AM to 6:00 AM EST.</p>

      <h3>What to Expect</h3>
      <ul>
        <li>The platform will be temporarily unavailable</li>
        <li>No data will be lost</li>
        <li>Performance improvements will be implemented</li>
        <li>New features will be deployed</li>
      </ul>

      <p>We appreciate your patience as we work to improve your experience.</p>
    `,
  },
  {
    slug: 'devotional-gratitude-in-service',
    title: 'Devotional: Gratitude in Service',
    date: '2024-10-20T12:00:00Z',
    description:
      "Reflect on the importance of gratitude as we serve others and teach God's word.",
    imageUrl: 'https://picsum.photos/seed/news10/400/250',
    content: `
      <h2>Gratitude in Service</h2>
      <blockquote>
        <p>Give thanks in all circumstances; for this is God's will for you in Christ Jesus.</p>
        <cite>– 1 Thessalonians 5:18</cite>
      </blockquote>

      <p>As we serve as study helpers, let's remember to cultivate hearts of gratitude. Every student is a gift, every lesson an opportunity, every challenge a chance to grow.</p>

      <h3>This Week's Challenge</h3>
      <p>Write down three things you're grateful for in your ministry work. Share them with a fellow study helper to encourage one another.</p>
    `,
  },
];

export interface HelpItem {
  id: string; // normalized lowercase key for lookup
  label: string;
  content: string; // HTML
}
export interface HelpCategory {
  id: string;
  label: string;
  items: HelpItem[];
}

export const helpSystemData: HelpCategory[] = [
  {
    id: 'course-study',
    label: 'COURSE STUDY',
    items: [
      {
        id: 'courses',
        label: 'Courses',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'certificates',
        label: 'Certificates',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'pending submissions',
        label: 'Pending Submissions',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'all graded submissions',
        label: 'All Graded Submissions',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'all graded/failed submissions',
        label: 'All Graded/Failed Submissions',
        content: '<p>Help content coming soon...</p>',
      },
    ],
  },
  {
    id: 'students',
    label: 'STUDENTS',
    items: [
      {
        id: 'student board',
        label: 'Student Board',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'students',
        label: 'Students',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'study activities',
        label: 'Study Activities',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'current study helper',
        label: 'Current Study Helper',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'study helper history',
        label: 'Study Helper History',
        content: '<p>Help content coming soon...</p>',
      },
    ],
  },
  {
    id: 'dashboard',
    label: 'DASHBOARD',
    items: [
      {
        id: 'dashboard',
        label: 'Dashboard',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'personal campaign',
        label: 'Personal Campaign',
        content: '<p>Help content coming soon...</p>',
      },
    ],
  },
  {
    id: 'follow-ups',
    label: 'FOLLOW-UPS',
    items: [
      {
        id: 'follow-ups',
        label: 'Follow-ups',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'follow-up requests',
        label: 'Follow-up Requests',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'all follow-up requests',
        label: 'All Follow-up Requests',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'pending requests',
        label: 'Pending Requests',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'pending follow-up requests',
        label: 'Pending Follow-up Requests',
        content: '<p>Help content coming soon...</p>',
      },
      {
        id: 'new follow-up request',
        label: 'New Follow-up Request',
        content: '<p>Help content coming soon...</p>',
      },
    ],
  },
  {
    id: 'profile',
    label: 'PROFILE',
    items: [
      {
        id: 'edit profile',
        label: 'Edit Profile',
        content: '<p>Help content coming soon...</p>',
      },
    ],
  },
];

export const getPaginatedActivities = (page: number, perPage = 20) => {
  const start = (page - 1) * perPage;
  const end = start + perPage;
  const items = mockActivities.slice(start, end);
  return {
    items,
    hasMore: end < mockActivities.length,
    total: mockActivities.length,
  };
};
